<template>
    <div>
        <div class="second-header-wrap">
            <el-button @click="$router.back()" type="default" size="medium">返回</el-button>
            <el-button @click="print()" type="primary" size="medium">打印</el-button>
        </div>

        <div class="questionnaire-container">

            <div class="questionnaire-content" ref="print" id="print">
                <div class="general-title">
                    <span class="general-title__title">{{noticeTitle}}</span>
                </div>
                <div class="basic-info-container">
                    <div>
                        <span class="basic-info-item">
                            <span class="basic-info-item__label">报名序号：</span>
                            <span class="basic-info-item__value">{{recruitNo}}</span>
                        </span>
                    </div>
                <span class="basic-info-item">
                    <span class="basic-info-item__label">学生姓名：</span>
                    <span class="basic-info-item__value">{{userName}}</span>
                </span>
                    <span class="basic-info-item">
                    <span class="basic-info-item__label">学生性别：</span>
                    <span class="basic-info-item__value">{{gender}}</span>
                </span>

                    <span class="basic-info-item">
                    <span class="basic-info-item__label">学生身份证/护照：</span>
                    <span class="basic-info-item__value">{{cardId}}</span>
                </span>
                    <span class="basic-info-item">
                    <span class="basic-info-item__label">学生生日：</span>
                    <span class="basic-info-item__value">{{birthday}}</span>
                </span>
                    <span class="basic-info-item">
                    <span class="basic-info-item__label">家长手机号：</span>
                    <span class="basic-info-item__value">{{mobile}}</span>
                </span>
                </div>
                <template v-for="(questionItem, questionIndex) in topicList">
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 1"
                        class="question-item quetion-item--single-choice"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value" v-if="optionItem.isSelected === 1" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                {{optionItem.optionTitle}}<span v-if="optionItem.isHaveReason === 1">（{{optionItem.optionAnswer}}）</span>
                            </div>
                        </div>

                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 2"
                        class="question-item quetion-item--multiple-choice"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                        </div>
                        <div class="question-item__choice" v-if="optionItem.isSelected === 1" v-for="(optionItem, optionIndex) in questionItem.optionList">
                            <div class="answers">
                                <div>
                                    {{optionItem.optionTitle}}
                                    <span v-if="optionItem.isHaveReason === 1" class="question-item__answer-area">
                                        （{{optionItem.optionAnswer}}）
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 3"
                        class="question-item quetion-item--pic-multiple-choice"
                    >
                        <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                        </div>
                        <div class="answers">
                            <image-previewer tag="richtext" viewclass="question-item__choice-pic" :images="questionItem.picList">
                                <div class="question-item__choice" v-if="optionItem.isSelected === 1" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                    <div class="question-item__choice-pic" :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                    <img class="print-img" :src="optionItem.optionPicUrl" />
                                    <div>{{optionItem.optionTitle}}</div>
                                    <div v-if="optionItem.isHaveReason === 1 && optionItem.isSelected === 1" class="question-item__answer-area">
                                        {{optionItem.optionAnswer}}
                                    </div>
                                </div>
                            </image-previewer>
                        </div>

                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 4"
                        class="question-item quetion-item--pic-multiple-choice"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                        </div>
                        <div class="answers">
                            <image-previewer tag="richtext" viewclass="question-item__choice-pic" :images="questionItem.picList">
                                <div class="question-item__choice" v-if="optionItem.isSelected === 1" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                    <div class="question-item__choice-pic" :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                    <img class="print-img" :src="optionItem.optionPicUrl" />
                                    <div>
                                        {{optionItem.optionTitle}}
                                    </div>
                                    <div v-if="optionItem.isHaveReason === 1" class="question-item__answer-area">
                                        （{{optionItem.optionAnswer}}）
                                    </div>
                                </div>
                            </image-previewer>
                        </div>

                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 5"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value">
                                {{questionItem.topicAnswer}}
                            </div>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 6"
                        class="question-item question-item--fill"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、<span v-html="questionItem.topicAnswer ? parseFillblank(questionItem.topicAnswer) : parseFillblankInput(questionItem.topicTitle)"></span>
                        </div>
                    </div>


                    <div
                        :key="questionIndex" v-if="questionItem.topType === 14"
                        class="question-item quetion-item--single-fill"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                        </div>
                        <div class="answers">
                            <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                <span v-if="optionItem.isSelected === 1" v-html="parseFillblank(optionItem.optionAnswer)"></span>
                                <span  v-else v-html="parseFillblankInput(optionItem.optionTitle)"></span>
                            </div>
                        </div>

                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 21"
                        class="question-item quetion-item--multiple-fill"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                        </div>
                        <div class="answers">
                            <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                <span v-if="optionItem.isSelected === 1" v-html="parseFillblank(optionItem.optionAnswer)"></span>
                                <span  v-else v-html="parseFillblankInput(optionItem.optionTitle)"></span>
                            </div>
                        </div>

                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 12"
                        class="question-item quetion-item--rate"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value">
                                <el-rate :value="questionItem.topicAnswer"></el-rate>
                            </div>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 9"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value">
                                {{questionItem.topicAnswer}}
                            </div>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 7"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicTitle}}&nbsp;&nbsp;
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 10"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                        </div>
                        <div class="question-item__answer-area">
                            <!--{{questionItem.topicAnswer}}-->
                            <template v-if="questionItem.topicAnswer">
                                <image-previewer tag="richtext" viewclass="pic-item" :images="questionItem.picList">
                                    <div class="pic-item" v-for="picItem in JSON.parse(questionItem.topicAnswer)" :style="{backgroundImage: `url(${picItem})`}"></div>
                                </image-previewer>
                            </template>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 11"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                        </div>
                        <div class="question-item__answer-area">
                            <template v-if="questionItem.topicAnswer">
                                <image-previewer tag="richtext" viewclass="pic-item" :images="questionItem.picList">
                                    <div class="pic-item" v-for="picItem in JSON.parse(questionItem.topicAnswer)" :style="{backgroundImage: `url(${picItem})`}"></div>
                                </image-previewer>
                            </template>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 8"
                        class="question-item question-item--qna"
                    >
                        <div class="divider"></div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 15"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value">
                                {{questionItem.topicAnswer}}
                            </div>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 16"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value">
                                {{questionItem.topicAnswer}}
                            </div>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 17"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value">
                                {{questionItem.topicAnswer}}
                            </div>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 18"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value">
                                {{questionItem.topicAnswer | toDate}}
                            </div>
                        </div>
                    </div>

                    <div
                        :key="questionIndex" v-if="questionItem.topType === 19"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            <div class="info-label">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="question-item__choice info-value">
                                {{questionItem.topicAnswer}}
                            </div>
                        </div>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import baseMixin from '@/mixins/baseMixin';
    import moment from 'moment';
    import BackTool from '@/components/BackTool';
    import {getVoteByRecruitUser} from '@/api/notice';
    import {
        getVoteTwoRecruitNotice
    } from '@/api/notice';

    export default {
        name: "signupDetail",
        data: function() {
            return {
                recruitNo: this.$route.query.recruitNo,
                userName: this.$route.query.userName,
                mobile: '',
                cardId: this.$route.query.cardId,
                gender: this.$route.query.gender,
                birthday: this.$route.query.birthday,
                expriyDate: '',
                voteId: this.$route.query.voteId,
                noticeId: this.$route.query.noticeId,
                noticeTitle: '',
                voteTitle: '',
                voteDesc: '',
                sendUserType: null,
                anonymous: null,
                topicList: [],
                voteStatus: null,
                isShowResult: null,
                maxVoteCount: 0,
                stuDepartJson: '{}',
                thScopeJson: '{}',

            }
        },
        mixins: [baseMixin],
        components: {
            BackTool,
            ImagePreviewer
        },
        filters: {
            getBirthday(value) {
                return `${value.substring(6, 10)}年${value.substring(10, 12)}月${value.substring(12, 14)}日`
            },
            toDate(date) {
                return date ? moment(date).format('YYYY-MM-DD') : '';
            },
            toTime(time) {
                return time ? moment(time).format('HH:mm') : '';
            },
            
        },
        created() {
            getVoteTwoRecruitNotice({
                noticeId: this.noticeId
            })
                .then(res => res.data)
                .then(data => {
                    this.noticeTitle = data.data.title;
                });
            getVoteByRecruitUser({
                voteId: this.voteId,
                cardId: this.cardId,
                noticeId: this.noticeId
            })
                .then(res => res.data)
                .then(data => {
                    const pageData = data.data;
                    pageData.topicList.forEach(item => {
                        if (item.topType === 4 || item.topType === 3) {
                            item.picList = item.optionList
                                .filter(item => item.isSelected === 1)
                                .map(item => ({src: item.optionPicUrl}));
                        }
                        if(item.topType === 10 || item.topType === 11) {
                            // console.log(item.topicAnswer)
                            if(item.topicAnswer && item.topicAnswer !== '' && item.topicAnswer !== '[]') {
                                item.picList = JSON.parse(item.topicAnswer).map(item => ({src: item}));
                            }
                        }
                    });
                    this.voteTitle = pageData.voteTitle;
                    this.voteDesc = pageData.voteDesc;
                    this.sendUserType = pageData.sendUserType;
                    this.expriyDate = pageData.expriyDate;
                    this.anonymous = pageData.anonymous;
                    this.topicList = pageData.topicList;
                    this.stuDepartJson = pageData.stuDepartJson;
                    this.thScopeJson = pageData.thScopeJson;
                    this.voteStatus = pageData.voteStatus;
                    this.isShowResult = pageData.isShowResult;
                    this.maxVoteCount = pageData.maxVoteCount;
                    this.mobile=pageData.voteTwoRecruitUser.mobile;
                });

        },
        methods: {
            print() {
                this.$print(this.$refs.print)
            },
            parseFillblank(title) {
                if(title) {
                    return title.replace(/{(.*?)}/g, (_, content) => {
                        return `<span style="border-bottom: 1px solid #000;">${content || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'}</span>`;
                    })
                }

            },
            parseFillblankInput(title) {
                if(title) {
                    return title.replace(/{(\d+?)}/g, function(_, num) {
                        return `<input type="text" style="border: 0;border-bottom: 1px solid #000; background: transparent;" disabled class="blank" maxlength="${num}" style="width: ${num * 20}px" />`
                    });
                } else {
                    return title;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../styles/mixin";

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
    .general-title {
        font-size: 26px;
        text-align: center;
        .general-title__title {
        }
        .recruit-no {
            float: left;
        }
    }

    .divider {
        border-bottom: 1px solid #999;
    }
    .page {
        padding: 20px;
    }
    .questionnaire-container {
        border: 1px solid #DBDBDB;
        width: 1024px;
        margin: 10px auto;
        box-sizing: border-box;
        & > * {
            margin: 10px 0;
        }
        .questionnaire-title {
            color: #4C4C4C;
            font-size: 22px;
            text-align: center;
        }
        .questionnaire-info {
            span {
                color: #55a1e3;
                margin: 0 5px;
            }
        }
        .questionnaire-content {
            height: 600px;
            overflow-y: auto;
            margin-top: 10px;
            padding: 30px 60px 0 60px;
        }
        .question-item {
            @include clearfix;
            margin-bottom: 20px;
            clear: both;

            & > * {
                margin: 5px 0;
            }
            .question-item__title {
                font-size: 16px;
                font-weight: 700;
                margin-left: -26px;
            }
            .question-item__type {
                font-size: 12px;
            }
            .question-item__choice-pic {
                @include cover-bg;
                @include wh(150px, 150px);
                margin-bottom: 5px;
            }
        }
        .quetion-item--pic-multiple-choice {
            .question-item__choice {
                float: left;
                margin-right: 14px;
            }
        }
    }
    .pic-item {
        float: left;
        @include cover-bg;
        @include wh(150px, 150px);
        margin: 0 10px 10px 0;
    }
    .basic-info-container {
        margin-left: -26px;
        width: 100%;
        box-sizing: border-box;
        padding: 10px 0;
        font-weight: bold;
        .basic-info-item {
            @include middleIB;
            margin-top: 20px;
            width: 48%;
            & > *{
                @include middleIB;
            }
            .basic-info-item__label {
                width: 35%;
                text-align: left;
            }
            .basic-info-item__value {
                color: #000;
            }
        }

    }
    .info-label {
        @include middleIB;
        min-width: 115px;
    }
    .info-value {
        @include middleIB;
        color:#000;
    }
    .answers {
        font-weight: bold;
        color: #000;
    }
    .print-img {
        display: none;
    }

    @media print {
        * {
            -webkit-print-color-adjust: exact;
        }
        .info-label, .info-value {
            display: block !important;
        }
        .question-item {
            margin-bottom: 20px !important;
        }
        .question-item__choice-pic {
            display: none !important;
        }
        .print-img {
            width: 150px !important;
            height:150px !important;
            display: block !important;
            margin-bottom: 5px !important;
        }
        .questionnaire-content {
            width: 1024px !important;
        }
        .question-item__choice {
            float: none !important;
        }
        .quetion-item--pic-multiple-choice {
            .question-item__choice {
                float: left !important;
                margin-right: 10px !important;
            }
        }
        .questionnaire-container .question-item .question-item__title {
            font-size: 16px !important;
            font-weight: 700 !important;
            margin: 5px 0 5px -26px !important;
        }
        .question-item__title {
            @include clearfix;
            & > * {
                float: left !important;
            }
        }
        .question-item--fill {
            .question-item__title {
                & > * {
                    float: none !important;
                }
            }

        }
        .questionnaire-container .question-item > * {
            margin: 5px 0 !important;
        }
        .basic-info-container {
            margin-left: 0 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/kindergarten/signup/SignupDetail.vue